export default {
  'referrer': () => import('./Referrer.vue'),
}
